/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAction, createSlice, createSelector } from '@reduxjs/toolkit';

import createRequestActionTypes from 'store/helpers/createRequestActionTypes';
import {
  handleClearErrors,
  onFailure,
  onSuccess,
} from 'store/helpers/commonHandlers';

const name = 'hospitals';

/** ActionType for Request */
export const [
  GET_HOSPITAL_DETAIL,
  GET_HOSPITAL_DETAIL_SUCCESS,
  GET_HOSPITAL_DETAIL_FAILURE,
] = createRequestActionTypes(name, 'GET_HOSPITAL_DETAIL');
export const [
  UPDATE_HOSPITAL,
  UPDATE_HOSPITAL_SUCCESS,
  UPDATE_HOSPITAL_FAILURE,
] = createRequestActionTypes(name, 'UPDATE_HOSPITAL');
export const [
  DELETE_HOSPITAL_HOLIDAY,
  DELETE_HOSPITAL_HOLIDAY_SUCCESS,
  DELETE_HOSPITAL_HOLIDAY_FAILURE,
] = createRequestActionTypes(name, 'DELETE_HOSPITAL_HOLIDAY');
export const [
  DELETE_HOSPITAL_DAY_HOLIDAY,
  DELETE_HOSPITAL_DAY_HOLIDAY_SUCCESS,
  DELETE_HOSPITAL_DAY_HOLIDAY_FAILURE,
] = createRequestActionTypes(name, 'DELETE_HOSPITAL_DAY_HOLIDAY');
export const [
  CREATE_HOSPITAL,
  CREATE_HOSPITAL_SUCCESS,
  CREATE_HOSPITAL_FAILURE,
] = createRequestActionTypes(name, 'CREATE_HOSPITAL');

const slice = createSlice({
  name,
  initialState: {
    detail: null,
    errors: {},
    next: {},
    count: {},
  },
  reducers: {
    clearErrors: handleClearErrors,
  },
  extraReducers: {
    [GET_HOSPITAL_DETAIL_SUCCESS]: onSuccess('detail'),
    [GET_HOSPITAL_DETAIL_FAILURE]: onFailure('detail'),
    [UPDATE_HOSPITAL_SUCCESS]: onSuccess('detail'),
    [UPDATE_HOSPITAL_FAILURE]: onFailure('update'),
    [DELETE_HOSPITAL_DAY_HOLIDAY_FAILURE]: onFailure('deleteDay'),
    [DELETE_HOSPITAL_HOLIDAY_FAILURE]: onFailure('deleteHoliday'),
    [CREATE_HOSPITAL_FAILURE]: onFailure('create'),
  },
});

/** Action for Request */
export const getHospitalDetail = createAction(GET_HOSPITAL_DETAIL);
export const updateHospital = createAction(UPDATE_HOSPITAL);
export const deleteHospitalHoliday = createAction(DELETE_HOSPITAL_HOLIDAY);
export const deleteHospitalDayHoliday = createAction(
  DELETE_HOSPITAL_DAY_HOLIDAY,
);
export const createHospital = createAction(CREATE_HOSPITAL);

/** General Action */
export const { clearErrors } = slice.actions;

/** Reducer */
export const hospitals = slice.reducer;

/** Selectors */
const errorSelector = createSelector(
  (state) => state.errors,
  (errors) => ({ errors }),
);
const detailSelector = createSelector(
  (state) => state.detail,
  (detail) => ({ hospitalDetail: detail }),
);
export const selectors = {
  errors: (state) => errorSelector(state[name]),
  detail: (state) => detailSelector(state[name]),
};

export default slice;
